import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { PageLinkModel } from '@helsenorge/core-cms/types/entities/cms.v1entities';
import type { BreadcrumbLink } from '@helsenorge/core-framework/breadcrumb';

const initialState: BreadcrumbLink = {
  name: 'Samvalg',
  url: '/',
  renderAsRouterLink: true,
};

const breadcrumbSlice = createSlice({
  name: 'breadcrumb',
  initialState,
  reducers: {
    breadcrumbChanged(state, action: PayloadAction<PageLinkModel>) {
      state.name = action.payload.displayName;
      state.url = action.payload.url;
      state.renderAsRouterLink = false;
    },
  },
});

export const { breadcrumbChanged } = breadcrumbSlice.actions;

export default breadcrumbSlice.reducer;
